module.exports = __webpack_public_path__ + "static/media/science.e1746ef7.jpg";